import { DeepReadonly } from '@src/utils/type-utils';
import { makeAutoObservable } from 'mobx';
import { BetPickDetail, KolStore } from './kol-store';

export class ProfilePageStore {
    leaderKey = '';

    constructor(private kolStore: KolStore) {
        makeAutoObservable(this, undefined, { deep: false });
    }

    get profile() {
        return this.kolStore.getProfile(this.leaderKey);
    }

    get raceDay() {
        return this.kolStore.getRaceDay(this.profile?.raceDayLink?.targetItem?.name);
    }

    get betpicks(): DeepReadonly<BetPickDetail[]> | undefined {
        const raceday = this.profile?.raceDayLink?.targetItem?.name;
        return this.kolStore.allBetPicks?.filter(
            (bp) =>
                bp.betpick.kol?.targetItem?.name === this.leaderKey &&
                bp.betpick.enabled?.boolValue &&
                bp.raceDay?.name === raceday
        );
    }
}
